// extracted by mini-css-extract-plugin
export default {"root":"Footer_root__6XQrs","edit":"Footer_edit__ifcfI","button":"Footer_button__BqkAQ","versionSelector":"Footer_versionSelector__v8hlI","aligner":"Footer_aligner__HkBwD"};